module.exports = __webpack_public_path__ + "static/img/total_order.5196ac2.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/total_order.png
// module id = uvHx
// module chunks = 0